if(!customElements.get('swym-wishlist-page')){
    class SwymWishlistPage extends HTMLElement{
        constructor(){
            super();
            this._initializeSwymComponent();
        }

        _init(swat){
            this._initializeSelectors(swat);
            this.isShareWishlistPage ? this._renderShareWishlist(swat) : this._renderWishlist(swat);
            this._attachEventListeners();
        }

        /* General funcions */

        _initializeSwymComponent(){
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }

        _initializeSelectors (swat){
            this.lists = [];
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.isShareWishlistPage = window.isShareListPage;
            this.isSingleList = !swat.retailerSettings.Wishlist.EnableCollections;
            this.isShareEnabledUsingSocialMedia = swat.retailerSettings.Wishlist.AllowSharing;
            this.isSFLEnabled = swat.retailerSettings.SFL.SFLFeatureEnabled;

            /* Page Header Selectors */ 

            this.accountButton = this.querySelector('#swymcs-user-login-status-btn');
            this.accountBar = this.querySelector('.account--details');
            this.header = this.querySelector('.swymcs-page-header');
            this.accountPopup = document.querySelector('#swymcs-user-login-status-popup');
            this.accountPopupCloseButton = document.querySelector('#swymcs-close-account-popup');
            this.accountPopupCancelButton = document.querySelector('#swymcs-cancel-account-popup');
            this.accountPopupActionButton = document.querySelector('#swymcs-account-login-action-button');
            this.accountPopupRegisterButton = document.querySelector('#swymcs-account-register-action-button');
            this.listSenderName = this.querySelector('#swymcs-lists-share-sender-details-name-value'); 
            this.listSenderEmail = this.querySelector('#swymcs-lists-share-sender-details-email-value');
            this.listSenderTier = this.querySelector('#swymcs-lists-share-sender-details-tier-value');
            this.pageTitleTabContainer = this.querySelector('#swymcs-title-wrapper');
            this.pageTitleWishlistTab = this.querySelector('#swymcs-page-title');
            this.pageTitleSFLTab = this.querySelector('#swymcs-sfl-page-title');

            /* Wishlist grid container */
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container'); 
            this.emptySFLListContainer = this.querySelector('#swym-empty-sfl-list-container'); 
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listsContainer = this.querySelector('#swymcs-lists-grid');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.wishlistHeader = this.querySelector('#swymcs-wishlist-header');
            this.backToListView = this.querySelector('#swymcs-back-to-lists-view');
            this.pageLoader = this.querySelector("#swymcs-loader-container");

            /* Lists header selectors */
            this.activeListContainer = this.querySelector('#swymcs-active-list');
            this.activeListImage = this.querySelector('#swymcs-active-list-image');
            this.activeListImageText = this.querySelector('#swymcs-active-list-image-text');
            this.activeListTilte = this.querySelector('#swymcs-active-list-title');
            this.activeListItemCount = this.querySelector('#swymcs-active-list-item-count');
            this.headerListsContainer = this.querySelector('#swymcs-header-lists');

            /* Additional Options selectors */ 

            this.additionalOptionsContainer = this.querySelector('#swymcs-additional-options');
            this.additionalOptionsBtn = this.querySelector('#swymcs-view-additional-options');
            this.shareListButton = this.querySelector('#swymcs-share-list');
            this.renameListButton = this.querySelector('#swymcs-rename-list');
            this.duplicateListButton = this.querySelector('#swymcs-duplicate-list');
            this.deleteListButton = this.querySelector('#swymcs-delete-list');
            this.addAlltoCartButton = this.querySelector('#swymcs-add-all');

            /* Additional Options popup selectors */
            this.additionalOptionsPopupContainer = document.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = document.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = document.querySelectorAll('.swymcs-additonal-popup-cancel-button');

                /* Share List popup selectors */ 
                this.shareListPopup = document.querySelector('#swymcs-share-list-popup');
                this.shareLinkField = document.querySelector('#swymcs-share-link-field');
                this.shareNameField = document.querySelector('#swymcs-share-name-field');
                this.shareEmailField = document.querySelector('#swymcs-share-email-field');
                this.shareMessageField = document.querySelector('#swymcs-share-message-field');
                this.shareListError = document.querySelector('#swymcs-share-email-field-error');
                this.emailShareButton = document.querySelector('#swymcs-confirm-share-list');
                this.additionalShareButtonsContainer = document.querySelector('.swymcs-additional-share-buttons-container');
                this.copyLinkButton = document.querySelector('#swymcs-confirm-share-list--copy');
                this.facebookShareButton = document.querySelector('#swymcs-confirm-share-list--facebook');
                this.twitterShareButton = document.querySelector('#swymcs-confirm-share-list--twitter');
                this.whatsappShareButton = document.querySelector('#swymcs-confirm-share-list--whatsapp');
                this.confirmShareContent = document.querySelector('.swymcs-confirm-share-content');
                this.successShareContent = document.querySelector('.swymcs-success-share-content');
                this.successShareEmail = document.querySelector('.swymcs-success-email');

                /* Delete List popup selectors */ 
                this.deleteListPopup = document.querySelector('#swymcs-delete-list-popup');
                this.deleteListName = document.querySelector('#swymcs-confirm-delete-list-name');
                this.confirmDeleteListButton = document.querySelector('#swymcs-confirm-delete-list'); 
                
                /* Rename List popup selectors */ 
                this.renameListPopup = document.querySelector('#swymcs-rename-list-popup');
                this.renameListName = document.querySelector('#swymcs-confirm-rename-list-name');
                this.renameListError = document.querySelector('#swymcs-rename-list-error');
                this.renameListTextField = document.querySelector('#swymcs-rename-list-field')
                this.confirmRenameListButton = document.querySelector('#swymcs-confirm-rename-list'); 

                /* Duplicate List popup selectors */ 
                this.duplicateListPopup = document.querySelector('#swymcs-duplicate-list-popup');
                this.duplicateListName = document.querySelector('#swymcs-confirm-duplicate-list-name');
                this.duplicateListError = document.querySelector('#swymcs-duplicate-list-error');
                this.duplicateListTextField = document.querySelector('#swymcs-duplicate-list-field');
                this.confirmDuplicateListButton = document.querySelector('#swymcs-confirm-duplicate-list');

            /* Mobile Size Drawer selectors */
            this.mobileSizeDrawer = document.querySelector('#swymcs-mobile-size-drawer');
            this.mobileSizeDrawerCloseButton = document.querySelector('#swymcs-close-mobile-size-drawer');
            this.mobileSizeOverlay = document.querySelector('#swymcs-mobile-size-overlay');
            this.mobileSizeVariant = document.querySelector('#swymcs-mobile-variant');
            this.mobileAtcBtn = document.querySelector('#swymcs-mobile-atc-btn');
        }

        _attachEventListeners(){

            this.body.addEventListener('click', evt => this._overlayEvent(evt));

            /* Adding events to page header elements */ 

            this.accountButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            this.addEventListener('click', evt => {
                const emptyWishlistLoginBtn = evt.target.closest('#swymcs-empty-wishlist-login-btn');
                if (!emptyWishlistLoginBtn) return;
                evt.preventDefault();
                this._showPopupContainer(this.accountPopup);
            });
            this.accountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            //this.accountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));
            this.accountPopupRegisterButton.addEventListener('click', this._loginButtonAction.bind(this));
            this.pageTitleTabContainer.addEventListener('click', this._toggleListView.bind(this));

            /* Header Lists Events */
            
            this.activeListContainer.addEventListener('click', evt => this._showPopupContainer(this.headerListsContainer));
            this.headerListsContainer.addEventListener('click', this._switchListsFromHeader);

            /* Additional Options Events */     
            this.additionalOptionsBtn.addEventListener('click', evt => this._showPopupContainer(this.additionalOptionsContainer));   
            this.additionalOptionsContainer.addEventListener('click', this._renderAdditionalOptionsPopup);
            this.shareListButton.addEventListener('click', this._renderShareListPopup.bind(this));
            this.addAlltoCartButton.addEventListener('click', this._addAllProductToCart.bind(this));

            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));
            this.mobileSizeDrawerCloseButton.addEventListener('click', () => this._hidePopupContainer(this.mobileSizeDrawer));
             
                /* Share List Events */
                this.copyLinkButton.addEventListener('click', (event) => {this._shareListByCopy(event.currentTarget);});
                this.emailShareButton.addEventListener('click', this._shareListByEmail.bind(this));
                this.facebookShareButton.addEventListener('click', evt => this._shareListOnPlatform('facebook'));
                this.twitterShareButton.addEventListener('click', evt => this._shareListOnPlatform('twitter'));
                this.whatsappShareButton.addEventListener('click', evt => this._shareListOnPlatform('whatsapp'));
                this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));
                this.shareMessageField.addEventListener('input', this._updateHeight.bind(this));
                this.shareMessageField.addEventListener('focus', this._updateHeight.bind(this));
                this.shareMessageField.addEventListener('blur', this._updateHeight.bind(this));


                /* Rename List Events */
                this.confirmRenameListButton.addEventListener('click', this._renameList.bind(this));
                this.renameListTextField.addEventListener('input', evt => this._validateListName(
                    this.renameListTextField.value.trim().toLowerCase(),
                    this.renameListError
                ))

                /* Duplicate List Events */
                this.confirmDuplicateListButton.addEventListener('click', this._duplicateList.bind(this));
                this.duplicateListTextField.addEventListener('input', evt => this._validateListName(
                    this.duplicateListTextField.value.trim().toLowerCase(),
                    this.duplicateListError
                ))

                /* Delete List Events */ 
                this.confirmDeleteListButton.addEventListener('click', this._deleteList.bind(this));

            /* Lists grid buttons */
            this.listsContainer.addEventListener('click', this._showListDetails);
            this.productsContainer.addEventListener('click', this._eventsForProductsGrid);
            this.mobileSizeDrawer.addEventListener('click', this._eventsForProductsGrid);
            this.backToListView.addEventListener('click', this._triggerBackToListView.bind(this));
        }

        async _triggerBackToListView(){
            this._renderMultipleList();
        }

        _showListDetails(evt){
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            if(target.getAttribute('id') != 'swymcs-lists-grid'){
                const lid = evt.target.closest('.swymcs-list-item').dataset.lid;
                const action = target?.dataset?.action || 'view-list';
                if(target.classList.contains('swymcs-view-list-button') && action == 'shop')
                    location.href = '/';
                else 
                page._renderListProducts(lid);   
            } return;  
        }
        
        async _renderWishlist(){
            this.lists = await this._getCompleteListDetails();
            this.lists.length ? (this.isSingleList ? this._renderSingleList() : this._renderMultipleList()) : this._renderEmptyState();
            this._renderSFLContents()
        }

        async _renderShareWishlist(){
            const lid = new URL(document.location).searchParams.get("lid");
            
            // Common UI updates
            const updateUI = (showHeader = true) => {
                this._showContainer(this.listProductsContainer);
                this._showContainer(this.wishlistContainer);
                this._hideContainer(this.pageLoader);
                this._hideContainer(this.backToListView);
                if (!showHeader) {
                    this._hideContainer(this.wishlistHeader);
                }
            };

            if(!lid){
                this._renderProductsGrid([]);
                updateUI(false);
                return;
            }

            window.currentActiveListId = lid;
            try {
                const wishlistProducts = await this._getProductsFromList(lid);
                this.listcontents = await this._getShopifyProductsData(wishlistProducts);         
                if(!this.listcontents || !this.listcontents.length){
                    this._renderEmptyList();
                    updateUI(false);
                    return;
                }
                
                await this._renderSharedListHeader(lid);
                this._renderProductsGrid(this.listcontents);
                if(window.isLoggedIn && window.isStoreOwner ) this._showCopyLinkInput();
                updateUI();
            } catch (error) {
                console.error('Error fetching wishlist products:', error);
                this._renderEmptyList();
                updateUI(false);
            }
        }

        async _renderSingleList() {
            if (this.list && this.list.listcontents) {
                this._hideContainer(this.pageLoader);
                this._showContainer(this.wishlistHeader);
                this._renderProductsGrid(this.list.listcontents);
                this._showContainer(this.wishlistContainer);
                this._showContainer(this.listProductsContainer);
                this._updateHeight();
                this._togglePlpEmptySection(!this.list.listcontents.length);
                return;
            }

            this.lists = await this._getLists();
            if (!this.lists.length) {
                this._renderEmptyState();
                return;
            }
            this.list = this.lists.find(list => list.lname.toLowerCase() == 'my wishlist') || this.lists[0];
            window.currentActiveListId = this.list.lid;
            this.list.listcontents = await this._getProductsFromList(this.list.lid);
            this.list.listcontents = await this._getShopifyProductsData(this.list.listcontents);
            // Cache the list data
            this.list = this._setListProperties(this.list, this.list.listcontents, true);

            this._hideContainer(this.pageLoader);
            /*if(window.isLoggedIn){
                this._showContainer(this.accountBar);
            }*/
            await this._renderSingleListHeader(this.list.lid);
            this._renderProductsGrid(this.list.listcontents);
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
            this._togglePlpEmptySection(!this.list.listcontents.length);
        }

        _renderMultipleList() {
            if(!this.lists.length){
                this._renderEmptyState();
                return;
            }
            this._renderListsView();
            /*if(window.isLoggedIn){
                this._showContainer(this.accountBar);
            }*/
            this.emptyListContainer.classList.add('swym-hide-container');
            this.wishlistContainer.classList.remove('swym-hide-container');
            this._togglePlpEmptySection(false);
        }

        _renderEmptyState(){
            this._hideContainer(this.pageLoader);
            /*if(window.isLoggedIn){
                this._showContainer(this.accountBar);
            }
            else {
                this._showContainer(this.header);
            }*/
            this.emptyListContainer.classList.remove('swym-hide-container');
            this.wishlistContainer.classList.add('swym-hide-container');
            this._togglePlpEmptySection(true);
        }

        _togglePlpEmptySection(show){
            const plpEmptySection = document.querySelector('.section-plp-empty');
            if(!plpEmptySection) return;
            plpEmptySection.style.display = show ? 'block' : 'none';
        }

        async _renderListsView(){
            window.currentActiveListId = '';
            const html = this.lists.map(list => {
                const productCount = list.totalProducts || 0;
                const buttonText = !productCount ? 'Continue Shopping' : 'View List';
                const buttonAction = !productCount ? 'shop' : 'view-list';
                
                const imageHtml = this._generateListPreviewImages(list);
                
                return `
                    <button class="swymcs-button swymcs-list-item swymcs-wishlist-grid-item" 
                            data-lid="${list.lid}" 
                            aria-label="View list ${list.lname}" 
                            id="list--${list.lid}">
                        <div class="swymcs-list-title-container">
                            <div class="swymcs-list-title">${list.lname}</div>
                        </div>
                        <div class="swymcs-list-product-count-container">
                            <span class="swymcs-product-count">${productCount}</span>
                            <span class="swymcs-product-count-text">${productCount > 1 ? 'products' : 'product'}</span>
                        </div>
                        ${imageHtml}
                        <div class="swymcs-view-list-button swymcs-major-button" 
                             data-action="${buttonAction}" 
                             id="swymcs-view-list-button-${list.lid}" 
                             aria-label="${buttonText}">
                            ${buttonText}
                        </div>
                    </button>
                `;
            }).join('');

            this.listsContainer.innerHTML = html;
            this._showContainer(this.listsContainer);
            this._hideContainer(this.listProductsContainer);
            this._hideContainer(this.pageLoader);
            //this._scrollToTop();
        }

        _generateListPreviewImages(list) {
            const listContents = list?.listcontents || [];
            let imageHtml = `<div class="swymcs-list-image-container">`;
            
            if(listContents.length) {
                for(let i = 0; i < 3; i++) {
                    if(listContents[i]) {
                        const product = listContents[i].productData;
                        const selectedVariant = product.variants.find(variant => variant.id === listContents[i].epi);
                        const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  listContents[i].iu;
                        imageHtml += `
                            <div class="swymcs-wishlist-image-wrapper">
                                <img src="${imageSrc}" 
                                     alt="${listContents[i].productData.title}" 
                                     class="swymcs-wishlist-image"/>
                            </div>`;
                    }
                }
                imageHtml += '</div>';
            } else {
                imageHtml += `<p class="swymcs-no-products-message">This is an empty list!</p></div>`;
            }
            
            return imageHtml;
        }

        async _renderListProducts(lid){
            this._hideContainer(this.listsContainer);
            this._showContainer(this.pageLoader);
            this._showContainer(this.wishlistHeader);
            this._showContainer(this.backToListView);
            this._showContainer(this.activeListContainer);
            window.currentActiveListId = lid;
            
            const selectedList = this.lists.find(list => list.lid == lid);
            if(!selectedList.allProductsLoaded) {
                // Load all products only when viewing full list
                const allProducts = await this._getProductsFromList(lid);
                selectedList.listcontents = await this._getShopifyProductsData(allProducts);
                selectedList.allProductsLoaded = true;
            }
            
            this._renderListHeader(lid);
            this._hideContainer(this.pageLoader);
            this._renderProductsGrid(selectedList.listcontents);
            this._showContainer(this.listProductsContainer);
        }

        async _renderSharedListHeader(lid){
            const { list: activeList } = await this._getListDetails(lid);
            activeList.listcontents = this.listcontents;
            this._renderActiveList(activeList);
            this.activeListContainer.style.pointerEvents = 'none';
            this._hideContainer(this.additionalOptionsBtn);
            this._hideContainer(this.shareListButton);
        }

        async _renderSingleListHeader(lid){
            this._renderActiveList(this.list);
            this.activeListContainer.style.pointerEvents = 'none';
            this._hideContainer(this.backToListView);
            this._hideContainer(this.pageLoader);
            this._hideContainer(this.renameListButton);
            this._hideContainer(this.duplicateListButton);
        }

        _renderListHeader(lid){
            const lists = this.lists; 
            const activeList = lists.find(list => list.lid == lid);
            this._renderActiveList(activeList);
            let html = ``;
            lists.forEach((list, index) => {
                const listContents = list?.listcontents || [];
                if(listContents.length){
                    const product = listContents[0].productData;
                    const selectedVariant = product.variants.find(variant => variant.id === listContents[0].epi);
                    const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image || listContents[0].iu;
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <img src="${imageSrc}" alt="${list.lname}"/>
                        <span class="swym-list-item">${list.lname} (${listContents.length})</span>
                    </li>`
                }else {
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <span class="swymcs-list-item-image-text">${list.lname[0]}</span>
                        <span class="swymcs-list-item">${list.lname} (0)</span>
                    </li>`
                }
            })
            this.headerListsContainer.innerHTML = html;
        }

        _renderActiveList(list){
            const listContent = list?.listcontents || [];
            this.activeListTilte.textContent = list.lname;
            this.activeListItemCount.textContent = `(${listContent.length})`;
            if(listContent.length){
                this.activeListImage.src = listContent[0].iu;
                this.activeListImage.alt = listContent[0].lname;
                this._hideContainer(this.activeListImageText);
                this._showContainer(this.activeListImage);
            }else {
                this.activeListImageText.textContent = list.lname[0];
                this.activeListImage.alt = listContent.lname;
                this._hideContainer(this.activeListImage);
                this._showContainer(this.activeListImageText);
            }
        }

        _renderProductsGrid(shopifyProducts, type = 'wishlist'){
            if(!shopifyProducts.length) {
                if(type == 'sfl') this._renderEmptySFLList();
                else this._renderEmptyList();
                return;
            }
            let productMarkup = ``;
            shopifyProducts.forEach(async (pdp, index) => {
                if(!pdp) return;
                const product = pdp.productData;
                const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                if(!selectedVariant) return;
                const sizeOptionIndex = product.options.findIndex(o => (o.name || o).toLowerCase() === 'size');
                let sizeOverlayHTML = '';
                let allSizesSoldOut = false;
                if (sizeOptionIndex === -1) {
                    allSizesSoldOut = !selectedVariant.available;
                    sizeOverlayHTML = `<div class="swymcs-size-overlay swymcs-one-size" style="display:none;"><span class="swymcs-size-overlay-item swymcs-size-selected" data-purpose="size-select" data-epi="${selectedVariant.id}"><span class="swymcs-size-label">One Size</span></span></div>`;
                } else {
                    const sizeKey = `option${sizeOptionIndex + 1}`;
                    const otherOptionKeys = ['option1','option2','option3'].filter((_, i) => i !== sizeOptionIndex);
                    const sizeVariants = product.variants.filter(v =>
                        otherOptionKeys.every(k => v[k] === selectedVariant[k])
                    );
                    allSizesSoldOut = sizeVariants.every(v => !v.available);
                    if (sizeVariants.length <= 1) {
                        sizeOverlayHTML = `<div class="swymcs-size-overlay swymcs-one-size" style="display:none;"><span class="swymcs-size-overlay-item swymcs-size-selected" data-purpose="size-select" data-epi="${selectedVariant.id}"><span class="swymcs-size-label">One Size</span></span></div>`;
                    } else {
                        const isConversion = sizeVariants[0]?.[sizeKey]?.includes(' / ');
                        const sizeItems = sizeVariants.map(v => {
                            const soldOut = !v.available ? 'swymcs-size-sold-out' : '';
                            const purpose = v.available ? 'data-purpose="size-select"' : '';
                            const fullSize = v[sizeKey];
                            const displaySize = isConversion ? fullSize.split(' / ').find(p => p.trim().startsWith('EU '))?.trim().slice(3) ?? fullSize : fullSize;
                            return `<span class="swymcs-size-overlay-item ${soldOut}" ${purpose} data-full-size="${fullSize}" data-epi="${v.id}"><span class="swymcs-size-label">${displaySize}</span></span>`;
                        }).join('');
                        sizeOverlayHTML = `<div class="swymcs-size-overlay" style="display:none;">${sizeItems}</div>`;
                    }
                }
                const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() !== 'default title'
                ? selectedVariant.title.split(' / ').map((part, i) => 
                    i === 1 
                        ? part.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ')
                        : part
                  ).join(' / ')
                : '';            
                const selectedVariantPrice = (selectedVariant.price / 100) % 1 === 0 ? (selectedVariant.price / 100).toString() : (selectedVariant.price / 100).toFixed(2);
                const selectedVariantCompareAtPrice = selectedVariant.compare_at_price > 0 && selectedVariant.compare_at_price != selectedVariant.price ? parseFloat(selectedVariant.compare_at_price/100.00).toFixed(2) : 0;
                const labelText = product.metafieldData != 'NA' ? product.metafieldData : '';
                let addToCartBtnText = allSizesSoldOut ? `${this.settings.sold_out_text}` : (selectedVariant.available ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? `${this.settings.added_to_cart_text}` : `${this.settings.add_to_cart_text}`) : `${this.settings.add_to_cart_text}`);
                const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                const lid = pdp.lid;
                let isSoldOut = allSizesSoldOut ? 'swymcs-sold-out' : '';
                let isButtonDisabled = isSoldOut ? 'disabled': '';
                let imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  pdp.iu;
                if (imageSrc && !/[?&]width=/.test(imageSrc)) {
                    imageSrc += (imageSrc.includes('?') ? '&' : '?') + 'width=540';
                }
                const productUrl = pdp?.product?.du || pdp.du;
                let variantsHTML = `<div class="swymcs-variant-selector container" bis_skin_checked="1">`;
                if(product.variants.length == 1){
                    let isVariantAvailable = selectedVariant.available ? 'data-available="true"' : 'data-available="false" style="text-decoration: line-through"';
                    variantsHTML += selectedVariant.title.toLowerCase() != 'default title' ? `<button ${isVariantAvailable} data-purpose="select" data-variant-id="${selectedVariant.id}" data-product-id="${product.id}" class="swym-selected-variant swymcs-variant-selector-btn" aria-label="Select ${selectedVariant.title}">${selectedVariant.title}</button>`: ''; 
                } else {
                    product.variants.forEach((variant, index) => {
                        const variantCost = parseFloat(variant.price/100.00).toFixed(2);
                        let isSelectedVariant = variant.id == selectedVariant.id ? 'swym-selected-variant' : ''; 
                        let isVariantAvailable = variant.available ? 'data-available="true"' : 'data-available="false" style="text-decoration: line-through"';
                        variantsHTML += `<button data-variant-cost="${variantCost}" data-purpose="select" ${isVariantAvailable} data-variant-id="${variant.id}" data-product-id="${product.id}" class="${isSelectedVariant} swymcs-variant-selector-btn" aria-label="Select ${variant.title}">${variant.title}</button>`;
                    })
                }

                variantsHTML += `</div>`;

                productMarkup += `
                    <li id="wishlist-grid-item--${index}"  data-url="${productUrl}" data-lid="${lid}" data-epi="${selectedVariant.id}" class="grid__item swymcs-product-card">
                        <div class="card-wrapper swymcs-list-product product-card-wrapper underline-links-hover" bis_skin_checked="1">
                            <button data-list-type="${type}" data-lid="${lid}" data-purpose="delete" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="${this.isShareWishlistPage && 'swym-hide-container'} swymcs-button swymcs-product-delete-btn" aria-label="Delete ${product.title}">
                                <span class="swym-icon">${this.settings.swym_delete_list_icon}</span>
                            </button>
                            <div class="card card--standard card--media" style="--ratio-percent: 100%;" bis_skin_checked="1">
                                <div class="card__inner color-scheme-2 gradient" style="--ratio-percent: 100%;" bis_skin_checked="1">
                                    <div class="card__media" bis_skin_checked="1">
                                        <div class="media media--transparent media--hover-effect" bis_skin_checked="1">
                                        <a href="${productUrl}" class="full-unstyled-link" aria-label="Visit ${product.title} page">
                                            <img src="${imageSrc}" alt="${product.title}" class="motion-reduce is-loaded" loading="lazy"/>
                                        </a>
                                        </div>
                                        ${sizeOverlayHTML}
                                    </div>
                                    <div class="card__content" bis_skin_checked="1">
                                        <div class="card__information" bis_skin_checked="1">
                                            
                                        </div>
                                        <div class="card__badge bottom left" bis_skin_checked="1"></div>
                                    </div>
                                </div>
                                <div class="card__content" bis_skin_checked="1">
                                    <div class="card__information" bis_skin_checked="1">
                                        <div class="card-information" bis_skin_checked="1">
                                            <div class="card-information-inner">
                                                <h3 class="card__heading">
                                                    <a href="${productUrl}" class="full-unstyled-link" aria-label="Visit ${product.title} page">
                                                        ${product.title}
                                                    </a>
                                                </h3>
                                                <div class="price " bis_skin_checked="1">
                                                    <div class="price__container" bis_skin_checked="1">
                                                        ${selectedVariantCompareAtPrice > 0 ? `
                                                            <div class="price__sale" bis_skin_checked="1">
                                                            <span class="price-item price-item--sale price-item--last">
                                                                ${selectedVariantPrice}${window.currencyCode}
                                                            </span>
                                                            <span>
                                                                <s class="price-item price-item--regular">${selectedVariantCompareAtPrice}${window.currencyCode}</s>
                                                            </span>
                                                            </div>` : `
                                                        <div class="price__regular" bis_skin_checked="1">
                                                            <span class="price-item price-item--regular">
                                                                ${selectedVariantPrice}${window.currencyCode}
                                                            </span>
                                                        </div>`
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="variant">
                                                ${(() => {
                                                    if (sizeOptionIndex === -1) return '';
                                                    const sizeKey = `option${sizeOptionIndex + 1}`;
                                                    const firstSize = product.variants[0]?.[sizeKey] || '';
                                                    if (!firstSize.includes(' / ')) return '';
                                                    return `<span class="variant__size-conversion-label">Select Size Conversion</span><span class="variant__size-conversion-options"><span class="swymcs-conversion-selected" data-purpose="size-conversion" data-conversion="EU">EU</span><span data-purpose="size-conversion" data-conversion="UK">UK</span><span data-purpose="size-conversion" data-conversion="US">US</span></span>`;
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card__badge bottom left" bis_skin_checked="1"></div>
                                <div class="swymcs-product-buttons">
                                    <button ${isButtonDisabled} data-purpose="cart" data-lid="${lid}" data-du="${pdp.du}" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-list-type="${type}" data-img="${imageSrc}"
                                        class="${isSoldOut} swymcs-major-button swymcs-add-to-cart-btn swymcs-button" aria-label="${addToCartBtnText}">
                                        ${addToCartBtnText}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </li>
                `;
            });
            this.productsContainer.innerHTML = productMarkup;
            this.productsContainer.classList.remove('swymcs-empty-list');
            //this._scrollToTop();
            setTimeout(() => {
                
                this._adjustMainPadding();
            }, 500);
        }

        _renderEmptySFLList(){
            this.productsContainer.classList.add('swymcs-empty-list');
            this.productsContainer.innerHTML = window.emptySFLListContent;
            this.productsContainer.querySelector('#swym-empty-sfl-list-container').classList.remove('swym-hide-container');
        }

        _renderEmptyList(){
            this.productsContainer.classList.add('swymcs-empty-list');
            this.productsContainer.innerHTML = window.emptyListContent;
            this.productsContainer.querySelector('#swym-empty-wishlist-container').classList.remove('swym-hide-container');
        }

        async _renderShareListPopup(evt){
            this._closeAdditionalOptionsPopup();
            this._renderShareList();
        }

        async _renderAdditionalOptionsPopup (evt) {
            const page = document.querySelector('swym-wishlist-page');
            const target = evt.target;
            if(target.id == 'swymcs-additional-options') return; 
            page._hidePopupContainer(page.querySelector('.swym-active-popup'));
            const action = target.dataset.action; 
            page._closeAdditionalOptionsPopup();
            if(action == 'share') page._renderShareList();
            else if(action == 'rename') page._renderRenameList();
            else if(action == 'duplicate') page._renderDuplicateList();
            else if(action == 'delete') page._renderDeleteList();
        }

        _closeAdditionalOptionsPopup () {
            this._hideContainer(this.shareListPopup);
            this._hideContainer(this.renameListPopup);
            this._hideContainer(this.duplicateListPopup);
            this._hideContainer(this.deleteListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
        }

        async _renderShareList() {
            if(!window.isLoggedIn) {
                this._hidePopupContainer(this.additionalOptionsContainer);
                this._showPopupContainer(this.accountPopup);
                return;
            }

            const list = this.lists.find(list => list.lid == window.currentActiveListId);
            const shareableLink = await this._prepareShareLink(list);
            this.shareLinkField.textContent = shareableLink;
            
            !this.isShareEnabledUsingSocialMedia && this._hideContainer(this.additionalShareButtonsContainer);
            this._showContainer(this.confirmShareContent);
            this._hideContainer(this.successShareContent);
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
            await this._markListAsPublic();
        }

        _markListAsPublic(){
            return new Promise(async (resolve, reject) => {
                this.swat.markListPublic(window.currentActiveListId,
                    list => resolve(list),
                    err => reject(err)
                );
            });
        }

        _renderRenameList () {
            this.renameListName.textContent = this.activeListTilte.textContent;
            this.renameListTextField.value = this.activeListTilte.textContent;
            this.renameListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.renameListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDuplicateList () {
            this.duplicateListName.textContent = this.activeListTilte.textContent;
            this.duplicateListTextField.value = 'Copy Of ' + this.activeListTilte.textContent;
            this.duplicateListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.duplicateListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDeleteList () {
            this.deleteListName.textContent = this.activeListTilte.textContent;
            this._showContainer(this.deleteListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        /* Show / Hide containers */

        _overlayEvent(evt){
            if (evt.target.nodeName == 'BODY') {
                document.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
              }
        }

        _scrollToTop () {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }

        _showPopupContainer (selector) {
            if (!selector.classList.contains('swymcs-drawer')) {
                selector.classList.remove('swym-hide-container');
            }
            selector.offsetHeight;
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }

        _hidePopupContainer (selector) {
            if (!selector.classList.contains('swymcs-drawer')) {
                selector.classList.add('swym-hide-container');
            }
            selector.classList.remove('swym-active-popup');
            if (selector.classList.contains('swymcs-drawer')) {
                setTimeout(() => this.body.classList.remove('no-scroll'), 200);
            } else {
                this.body.classList.remove('no-scroll');
            }
        }

        _showContainer (selector) {
            selector.classList.remove('swym-hide-container');
        }

        _hideContainer (selector) {
            selector.classList.add('swym-hide-container');
        } 

        /* Javascript APIs related functions */
        _getLists () {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchLists({
                  callbackFn: lists => resolve(lists),
                  errorFn: err => reject(err)
                });
            });
        } 

        _getListDetails(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListDetails(
                  { lid: lid },
                  list => resolve(list),
                  error => reject(error)
                );
            });
        }

        async _getCompleteListDetails(){
            const lists = await this._getLists();
            if(!lists.length) return lists;
            
            // Load only first 3 products for each list for preview
            await Promise.all(lists.map(async list => {
                const products = await this._getProductsFromList(list.lid);
                list.listcontents = products.slice(0, 3); // Only get first 3 products for preview
                list.listcontents = await this._getShopifyProductsData(list.listcontents);
                if(products.length <= 3) list.allProductsLoaded = true;
                list.totalProducts = products.length; // Store total count
            }));
            return lists;
        }

        _getProductsFromList(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListCtx(
                  { lid: lid },
                  listContents => resolve(listContents),
                  error => reject(error)
                );
            });
        }
      
       async _getShopifyProductsData(products){
            if(!products.length) return []; 
            const section = this;   
            let buggedProductsArray = []; 
            let res = await Promise.all(products.map(async (pdp) => {
                try {
                    const productHandleString = pdp.du.split('/products/')[1];
                    const productHandle = productHandleString.split('?')[0];
                    const reqURL = `/products/${productHandle}`;
                    const productData = await fetch(`${reqURL}.js`);
                    const jsonData = await productData.json();
                    if(!jsonData.variants.some(variant => variant.id === pdp.epi)){
                        throw new Error(`Wishlisted variant ${pdp.epi} no longer exists on product ${productHandle}`);
                    }
                    pdp.productData = jsonData;
                    return pdp;
                }
                catch(error){
                    const errorObj = {}; 
                    errorObj[pdp.du] = error; 
                    buggedProductsArray.push(errorObj);
                    return null; 
                }
            }));

            console.log('Products with bugs - ', buggedProductsArray);
            res = res.filter(product => product && product.productData);
            return res;
        }

        _setListProperties(list, listContents, allProductsLoaded = false) {
            list.listcontents = listContents;
            list.totalProducts = listContents.length;
            list.allProductsLoaded = allProductsLoaded;
            return list;
        }

        _adjustMainPadding() {
            const main = document.querySelector('main');
            if (!main) return;
            // Use visualViewport.height if available, fallback to innerHeight
            const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
          
            // Detect if the device is an iPhone
            const isIPhone = /iPhone/i.test(navigator.userAgent);
          
            const styles = window.getComputedStyle(main);
            const paddingBottom = parseFloat(styles.paddingBottom) || 0;
            const marginTop = parseFloat(styles.marginTop) || 0;
            const heightWithoutPadding = main.offsetHeight - paddingBottom;
            const height = heightWithoutPadding + marginTop;
          
            // Adjust padding to fill the effective viewport
            if (height < vh) {
              const newPadding = vh - height;
              main.style.paddingBottom = `${newPadding}px`;
            } else {
              main.style.paddingBottom = '0px';
            }
          }
        _deleteProductFromList(product, lid, parentNode, listType){
            const onSuccessWishlist = async deletedProduct => {
                parentNode.remove();
                if(!this.productsContainer.querySelector('.swymcs-product-card')){
                    this._renderProductsGrid([]);
                }
                if(this.isSingleList) {
                    this.list.listcontents = this.list.listcontents.filter(product => product.epi !== deletedProduct.epi);
                    this.list = this._setListProperties(this.list, this.list.listcontents, true);
                    this._renderSingleListHeader(lid);
                    this._togglePlpEmptySection(!this.list.listcontents.length);
                } else {
                    this.lists = this.lists.map(list => {
                        if (list.lid === lid) {
                            const updatedListContents = list.listcontents.filter(product => product.epi !== deletedProduct.epi);
                            return this._setListProperties({...list}, updatedListContents, true);
                        }
                        return list;
                    });
                    this._renderListHeader(lid); 
                }
            }

            const onSuccessSFL = async response => {
                const deletedProduct = response.itemsdeleted[0];
                parentNode.remove();
                if(!this.productsContainer.querySelector('.swymcs-product-card')){
                    this._renderProductsGrid([], 'sfl');
                }
                this.sflList.listcontents = this.sflList.listcontents.filter(product => product.epi !== deletedProduct.epi);
            }
            const onError = error => console.log("Error while deleting the Product", error)
            if(listType == 'wishlist') this.swat.deleteFromList(lid, product, onSuccessWishlist, onError);
            else if(listType == 'sfl') this.swat.SaveForLater.remove(lid, [product], onSuccessSFL, onError);
        }

        _renameList(){
            const listName = this.renameListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.renameListError);
            if(!isValidListName) return;
            const listUpdateConfig = {
                "lid": window.currentActiveListId,
                "lname": listName,
            };
            const onSuccess = async (updatedListObj) => {
                this._closeAdditionalOptionsPopup();
                const listcontents = this.lists.find(list => list.lid === updatedListObj.lid).listcontents;
                this.lists = this.lists.map(list => list.lid === updatedListObj.lid ? this._setListProperties(updatedListObj, listcontents, true) : list);
                this._renderListHeader(window.currentActiveListId);
            }
            const onError = error => console.log(`Error while Renaming the List, ${window.currentActiveListId}`, error);
            _swat.updateList(listUpdateConfig, onSuccess, onError);
        }

        _duplicateList(){
            const listName = this.duplicateListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.duplicateListError);
            if(!isValidListName) return;
            const listConfig = {
                "lname": listName,
                "fromlid": window.currentActiveListId,
            };
            const onSuccess = async (listObj) => {
                const listContents = this.lists.find(list => list.lid === window.currentActiveListId).listcontents;
                this.lists.unshift(this._setListProperties(listObj, listContents, true));
                this._hideContainer(this.listProductsContainer);
                this._renderListProducts(listObj.lid);
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => console.log(`Error while duplicating the List, ${lid}`, error);
            _swat.createList(listConfig, onSuccess, onError);
        }

        _deleteList(){
            const onSuccess = deletedListObj => {
                this._closeAdditionalOptionsPopup();
                this.lists = this.lists.filter(list => list.lid != window.currentActiveListId);
                this._hideContainer(this.listProductsContainer);
                this._showContainer(this.pageLoader);
                if(this.isSingleList) {
                    this.list = null;
                }
                this.isSingleList ? this._renderSingleList() : this._renderMultipleList();
            }
            const onError = error => console.log(`Error while deleting the List, ${lid}`, error);
            _swat.deleteList(window.currentActiveListId, onSuccess, onError);
        }

        _validateListName(name, errorField){
            const isValidList = false;
            if(name.length < 3){
                errorField.textContent = 'Name must be longer than 3 characters';
                return isValidList; 
            }
            const lists = this.lists;
            const matchedList = lists.find(list => list.lname.trim().toLowerCase() == name);
            if(matchedList) {
                errorField.textContent = 'List name already exists';
                return isValidList;
            }
            errorField.textContent = '';
            return !isValidList;
        }

        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value=='' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if(isBlank || isInvalidString){
                this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }

        _refreshAndOpenCartDrawer() {
            fetch('/cart?section_id=cart-drawer&t=' + Date.now())
                .then(r => r.text())
                .then(text => {
                    const html = new DOMParser().parseFromString(text, 'text/html');
                    const cartDrawer = document.querySelector('cart-drawer');
                    if (!cartDrawer) return;
                    const fetchedDrawer = html.querySelector('cart-drawer');
                    if (fetchedDrawer) {
                        const isEmpty = fetchedDrawer.classList.contains('is-empty');
                        cartDrawer.classList.toggle('is-empty', isEmpty);
                        if (!isEmpty) cartDrawer.querySelector('.drawer__inner-empty')?.remove();
                    }
                    ['cart-drawer-items', '.cart-drawer__footer'].forEach(sel => {
                        const target = document.querySelector(sel);
                        const source = html.querySelector(sel);
                        if (target && source) target.replaceWith(source);
                    });
                    const checkout = document.getElementById('CartDrawer-Checkout');
                    if (checkout) checkout.disabled = false;
                    cartDrawer.open();
                });
        }

        _addProductToCart(button){
            const epi = +button.dataset.epi;
            const empi = +button.dataset.empi;
            const du = button.dataset.du;
            this.swat.replayAddToCart({
                empi,
                du,
                qty: 1
            }, epi, (c) => {
                if (this.isShareWishlistPage) {
                    button.classList.add('swymcs-product-in-cart');
                    button.classList.remove('swymcs-adding-to-cart');
                    button.textContent = 'Added to cart';
                }
                this._refreshAndOpenCartDrawer();
                const mobileDrawer = button.closest('#swymcs-mobile-size-drawer');
                if (mobileDrawer) this._hidePopupContainer(mobileDrawer);
                const card = button.closest('.swymcs-product-card') || button._sourceCard;
                const originalEpi = card?.dataset.epi ?? button.dataset.epi;
                if (!this.isShareWishlistPage) this._deleteProductFromList(
                    {
                        "epi": originalEpi,
                        "empi": button.dataset.empi,
                        "du": button.dataset.du
                    }, button.dataset.lid, card, button.dataset.listType
                );
                /*const sidebarCart = document.querySelector('[data-action="open-drawer"]');
                setTimeout(() => {
                    sidebarCart.click();
                }, 700);*/
            }, (error) => {
                button.classList.remove('swymcs-adding-to-cart');
                button.textContent = 'Add to cart';
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
            });
        }

        async _addAllProductToCart(evt) {
            const page = this;
            const buttons = [];
            try {
                const productsData = [...page.querySelectorAll('.swymcs-product-card .swymcs-add-to-cart-btn:not(:disabled)')].map(container => ({
                    id: +container.dataset.epi,
                    quantity: 1
                }));
                let formData = { 'items': productsData };
        
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                });
        
                const cartResponse = await response.json();
                cartResponse.items.forEach(item => {
                    const variantId = item.id;
                    const button = page.querySelector(`.swymcs-add-to-cart-btn[data-epi="${variantId}"]`);
                    button.textContent = 'Added to cart';
                    if (button) buttons.push(button);
                });
                evt.target.textContent = 'Added to cart';
                const sidebarCart = document.querySelector('[data-action="open-drawer"]');
                setTimeout(() => {
                    sidebarCart.click();
                }, 700);
                this._scrollToTop();
                this._refreshAndOpenCartDrawer();
                if (!this.isShareWishlistPage) buttons.forEach(button => {
                    page._deleteProductFromList(
                      {
                        "epi": button.dataset.epi,
                        "empi": button.dataset.empi,
                        "du": button.dataset.du
                      },
                      button.dataset.lid,
                      button.closest('.swymcs-product-card'),
                      button.dataset.listType
                    );
                });
            } catch (error) {
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
                console.error('Error:', error);
            }
        }

        _prepareShareLink(list){
            return new Promise(async (resolve, reject) => {
                this.swat.generateSharedListURL(list.lid,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }

        _shareListByCopy(target){
            const textSpan = target.querySelector('.swymcs-share-button-text');
            navigator.clipboard.writeText(this.shareLinkField.textContent)
            .then(() => {
                const originalText = textSpan.textContent;
                textSpan.textContent = 'Copied';
                setTimeout(() => {
                    textSpan.textContent = originalText;
                }, 3000);
            })
            .catch(error => _swat.ui.uiRef.showErrorNotification({ message: error.description }));
        }

        _shareListByEmail(){
            if(!this._validateEmail()) return;
            const email = this.shareEmailField.value.trim();
            const onSuccess = response => {
                this.successShareEmail.textContent = email;
                this._hideContainer(this.confirmShareContent);
                this._showContainer(this.successShareContent);
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window.currentActiveListId,
            }, onSuccess, onError);
        }

        _shareListOnPlatform(platform){
            const shareUrl = this.shareLinkField.textContent;
            const note = this.shareMessageField.value;
            const fromName = this.shareNameField.value;
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            let platformShareUrlTemplate = '';
            if(platform == 'facebook') 
                platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
            else if(platform == 'twitter')  
                platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`; 
            else if (platform == 'whatsapp')
                platformShareUrlTemplate = `https://api.whatsapp.com/send?text=${encodeURIComponent(note + " " + shareUrl)}`;
            _swat.shareListSocial(window.currentActiveListId, fromName, platformShareUrlTemplate, platform, note, onError)
        }

        async _renderSFLContents(){
            if(!this.isSFLEnabled || this.isShareWishlistPage) return;
            this.sflList = await this._getSflList();
            window.saveForLaterListId = this.sflList.listid;
            const sflProducts = await this._getSflProducts();
            this.sflList.listcontents = await this._getShopifyProductsData(sflProducts);
            this._showContainer(this.pageTitleSFLTab);
        }

        _getSflList() {
            return new Promise(async (resolve, reject) => {
                this.swat.SaveForLater.init(
                    (list) => resolve(list),
                    (error) => reject(error)
                );
            });
        }

        async _getSflProducts(){
            return new Promise(async (resolve, reject) => {
                this.swat.SaveForLater.fetch(
                  window.saveForLaterListId,
                  (products) => resolve(products.items),
                  (error) => reject(error)
                );
            });
        }

        async _renderSFLContainer(){
            this._hideContainer(this.listsContainer);
            this._hideContainer(this.wishlistHeader);
            this._hideContainer(this.backToListView);
            this._hideContainer(this.emptyListContainer);
            this._hideContainer(this.emptySFLListContainer);
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
            this._renderProductsGrid(this.sflList.listcontents, "sfl");
        }

        /* Header functions */

        _loginButtonAction(evt){
            const redirectionUrl = evt.currentTarget.getAttribute('data-redirection-url');
            const actionUrl = evt.currentTarget.getAttribute('data-action-url');
            localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl);
            localStorage.setItem('SWYM_ACTION_URL', actionUrl);
            // This popup's "Log In" button is the single choke point every login
            // entry point on this page funnels through (the empty-list button and
            // the #swymcs-user-login-status-btn header icon both just open this
            // same popup) - main-account.liquid reads this key back once Shopify
            // lands the now-authenticated customer on /account, and sends them
            // here instead. SWYM_REDIRECT_URL above is never actually read by
            // anything, kept as-is rather than risk removing a Swym-relied-on key.
            try { sessionStorage.setItem('postLoginRedirect', redirectionUrl); } catch (err) {}
            location.href = actionUrl;
        }

        async _switchListsFromHeader (evt){
            const page = document.querySelector('swym-wishlist-page');
            const lid = evt.target.dataset.lid;
            page._hideContainer(page.listProductsContainer);
            page._renderListHeader(window.currentActiveListId);
            page._renderListProducts(lid);
            page._hidePopupContainer(page.headerListsContainer);
        }

        _toggleListView(evt){
            if(!this.isSFLEnabled || this.isShareWishlistPage) return;
            const target = evt.target;
            if(target.classList.contains('swymcs-active-tab') && !target.classList.contains('swymcs-page-title')) return;
            this.pageTitleTabContainer.querySelectorAll('.swymcs-page-title').forEach(tab => tab.classList.remove('swymcs-active-tab'));
            target.classList.add('swymcs-active-tab');
            if(target.dataset.type == 'wishlist'){
                this.isSingleList ? this._renderSingleList() : this._renderMultipleList();
            } 
            else if(target.dataset.type == 'sfl') this._renderSFLContainer();
        }

        /* Product Grid Events */
        
        async _eventsForProductsGrid (evt) {
            const target = evt.target.closest('[data-purpose]') || evt.target;
            const page = document.querySelector('swym-wishlist-page');
            const purpose = target.dataset?.purpose;
            if(!purpose) return;
            evt.preventDefault();
            if(purpose == 'cart') {
                const card = target.closest('.swymcs-product-card');
                if (card) {
                    if (window.innerWidth <= 767) {
                        const mobileDrawer = page.mobileSizeDrawer;
                        if (mobileDrawer) {
                            const sourceOverlay = card.querySelector('.swymcs-size-overlay');

                            if (sourceOverlay?.classList.contains('swymcs-one-size')) {
                                const oneSize = sourceOverlay.querySelector('.swymcs-size-overlay-item');
                                target.dataset.epi = oneSize.dataset.epi;
                                target.dataset.purpose = 'cart-ready';
                                target.classList.add('swymcs-adding-to-cart');
                                target.classList.remove('swymcs-sold-out');
                                target.textContent = 'Adding to Cart...';
                                target._swymProductPage = page;
                                page._addProductToCart(target);
                            } else {
                                const mobileOverlay = page.mobileSizeOverlay;
                                const mobileVariant = page.mobileSizeVariant;
                                const mobileBtn = page.mobileAtcBtn;

                                // Populate size tiles
                                mobileOverlay.innerHTML = sourceOverlay ? sourceOverlay.innerHTML : '';

                                // Show/hide size conversion selector
                                const hasConversion = sourceOverlay?.querySelector('[data-full-size*=" / "]');
                                mobileVariant.style.visibility = hasConversion ? 'visible' : 'hidden';
                                mobileVariant.querySelectorAll('.variant__size-conversion-options span').forEach((el, i) => {
                                    el.classList.toggle('swymcs-conversion-selected', i === 0);
                                });

                                // Reset size selection
                                mobileOverlay.querySelectorAll('.swymcs-size-overlay-item').forEach(el => el.classList.remove('swymcs-size-selected'));

                                // Set up ATC button
                                mobileBtn.dataset.empi = target.dataset.empi;
                                mobileBtn.dataset.du = target.dataset.du;
                                mobileBtn.dataset.lid = target.dataset.lid;
                                mobileBtn.dataset.listType = target.dataset.listType;
                                mobileBtn._sourceCard = card;
                                mobileBtn.classList.remove('swymcs-sold-out', 'swymcs-adding-to-cart', 'swymcs-product-in-cart');
                                mobileBtn.removeAttribute('disabled');
                                mobileBtn.dataset.purpose = 'cart';
                                mobileBtn.textContent = 'Select Size';
                                mobileBtn.classList.add('swymcs-sold-out');

                                page._showPopupContainer(mobileDrawer);
                            }
                        }
                    } else {
                        const overlay = card.querySelector('.swymcs-size-overlay');
                        if (overlay) {
                            if (overlay.classList.contains('swymcs-one-size')) {
                                const oneSize = overlay.querySelector('.swymcs-size-overlay-item');
                                target.dataset.epi = oneSize.dataset.epi;
                                target.dataset.purpose = 'cart-ready';
                                target.classList.add('swymcs-adding-to-cart');
                                target.classList.remove('swymcs-sold-out');
                                target.textContent = 'Adding to Cart...';
                                page._addProductToCart(target);
                            } else {
                                overlay.style.display = 'flex';
                                const variantDiv = card.querySelector('.variant');
                                if (variantDiv) variantDiv.style.visibility = 'visible';
                                const hasPreselected = overlay.querySelector('.swymcs-size-selected');
                                if (!hasPreselected) {
                                    target.classList.add('swymcs-sold-out');
                                    target.textContent = 'Select Size';
                                }
                            }
                        }
                    }
                }
            }
            else if(purpose == 'cart-ready') {
                target.classList.add('swymcs-adding-to-cart');
                target.classList.remove('swymcs-sold-out');
                target.textContent = 'Adding to Cart...';
                page._addProductToCart(target);
            }
            else if(purpose == 'size-conversion') {
                const card = target.closest('.swymcs-product-card');
                const mobileDrawer = target.closest('#swymcs-mobile-size-drawer');
                const container = card || mobileDrawer;
                if (container) {
                    container.querySelectorAll('.variant__size-conversion-options span').forEach(el => el.classList.remove('swymcs-conversion-selected'));
                    target.classList.add('swymcs-conversion-selected');
                    const conversion = target.dataset.conversion;
                    const overlayItems = card
                        ? card.querySelectorAll('.swymcs-size-overlay-item')
                        : mobileDrawer.querySelector('#swymcs-mobile-size-overlay').querySelectorAll('.swymcs-size-overlay-item');
                    overlayItems.forEach(el => {
                        const fullSize = el.dataset.fullSize;
                        if (!fullSize?.includes(' / ')) return;
                        const part = fullSize.split(' / ').find(p => p.trim().startsWith(conversion + ' '));
                        const label = el.querySelector('.swymcs-size-label');
                        const text = part ? part.trim().slice(conversion.length + 1) : fullSize;
                        if (label) label.textContent = text; else el.textContent = text;
                    });
                }
            }
            else if(purpose == 'size-select') {
                const overlay = target.closest('.swymcs-size-overlay');
                if (overlay) {
                    overlay.querySelectorAll('.swymcs-size-overlay-item').forEach(el => el.classList.remove('swymcs-size-selected'));
                    target.classList.add('swymcs-size-selected');
                    const card = target.closest('.swymcs-product-card');
                    const mobileDrawer = target.closest('#swymcs-mobile-size-drawer');
                    const cartBtn = card?.querySelector('.swymcs-add-to-cart-btn') || mobileDrawer?.querySelector('#swymcs-mobile-atc-btn');
                    if (cartBtn) {
                        cartBtn.classList.remove('swymcs-sold-out');
                        cartBtn.classList.add('swymcs-adding-to-cart');
                        cartBtn.removeAttribute('disabled');
                        cartBtn.textContent = 'Adding to Cart...';
                        cartBtn.dataset.epi = target.dataset.epi;
                        cartBtn.dataset.purpose = 'cart-ready';
                        page._addProductToCart(cartBtn);
                    }
                }
            }
            else if(purpose == 'select') page._selectProductSize(target);
            else if (purpose == 'delete'){
                page._deleteProductFromList(
                    {
                        "epi": target.dataset.epi,
                        "empi": target.dataset.empi,
                        "du": target.dataset.du
                    }, target.dataset.lid, target.closest('.swymcs-product-card'), target.dataset.listType
                );
            }
        }

        _selectProductSize(sizeButton){
            const selectedVariantClass = 'swym-selected-variant';
            const parentNode = sizeButton.closest('.swymcs-product-card');
            // If selected variant is clicked - DO NOTHING
            if(sizeButton.classList.contains(selectedVariantClass)) return; 

            // Switch selected variants
            parentNode.querySelector(`.${selectedVariantClass}.swymcs-variant-selector-btn`).classList.remove(selectedVariantClass);
            sizeButton.classList.add(selectedVariantClass);

            const addToCartButton = parentNode.querySelector('.swymcs-add-to-cart-btn');
            const isVariantAvailable = sizeButton.dataset.available == 'true';
            const variantId = sizeButton.dataset.variantId;
            const variantCost = sizeButton.dataset.variantCost;
            const priceContainer = parentNode.querySelector('.price-item.price-item--regular');

            // Perform proper logical functions
            isVariantAvailable ? addToCartButton.removeAttribute('disabled') : addToCartButton.setAttribute('disabled', '');
            addToCartButton.classList.toggle('swymcs-sold-out', !isVariantAvailable);
            addToCartButton.classList.remove('swymcs-adding-to-cart');
            let addToCartBtnText = this.settings.sold_out_text;
            if(isVariantAvailable) {
                addToCartBtnText = this.swat.platform.isInDeviceCart(variantId) ? `${this.settings.added_to_cart_text}` : `${this.settings.add_to_cart_text}`;
            }
            addToCartButton.setAttribute('data-epi', variantId);
            addToCartButton.setAttribute('data-variant-cost', variantCost);
            addToCartButton.textContent = addToCartBtnText;
            priceContainer.textContent = `${window.currencyCode}${variantCost}`;
        }

        _updateHeight() {
            const textarea = this.shareMessageField;
            const style = window.getComputedStyle(textarea);
            const lineHeight = parseFloat(style.lineHeight);
          
            if (!textarea.value) {
              textarea.style.height = document.activeElement === textarea
                ? (lineHeight * 3) + 'px'  // focused → 2 lines
                : '0px';                  // unfocused → 0
            } else {
              // Has content → auto-expand
              textarea.style.height = 'auto'; 
              textarea.style.height = textarea.scrollHeight + 'px';  
            }
        }

        /* Additional Options */
    }
    customElements.define('swym-wishlist-page', SwymWishlistPage);
}